"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var componentStyle = {
    base: {
        width: '100%',
        textAlign: 'left',
        borderCollapse: 'collapse',
    },
    headers: {
        padding: '8px 10px',
        fontWeight: 400,
        borderTop: '1px solid',
        borderBottom: '2px solid',
    },
};
exports.PropertyTable = function (_a) {
    var children = _a.children;
    return (React.createElement("table", { style: componentStyle.base },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { style: componentStyle.headers }, "Name"),
                React.createElement("th", { style: componentStyle.headers }, "Type"),
                React.createElement("th", { style: componentStyle.headers }, "Default"),
                React.createElement("th", { style: componentStyle.headers }, "Description"))),
        React.createElement("tbody", null, children)));
};
exports.PropertyTable.displayName = 'PropertyTable';



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Properties/PropertyTable.tsx
// module id = 624
// module chunks = 0